import { render, staticRenderFns } from "./AddPortalContentModal.vue?vue&type=template&id=19660ed4&"
import script from "./AddPortalContentModal.vue?vue&type=script&lang=js&"
export * from "./AddPortalContentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports